const FIRST_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

/**
 * Initials for a placeholder avatar: the first letter or digit of the first two
 * words that have one. "The Beau Hunks Orchestra" → "TB", "madonna" → "M".
 * Returns "♪" when the name has no letter or digit.
 */
export const getAvatarInitials = (name: string): string => {
  const initials = name
    .split(/\s+/)
    .map((word) => FIRST_LETTER_OR_DIGIT.exec(word)?.[0])
    .filter((char): char is string => char !== undefined)
    .slice(0, 2)
    .join('')
    .toLocaleUpperCase();
  return initials === '' ? '♪' : initials;
};
